/**
 * BASEBALL PARTNER DRILLS DATA STRUCTURE
 *
 * ID RANGE:
 * - Partner Baseball drills: 6501–6510
 *
 * SAFETY:
 * - Use a soft ball or tennis ball indoors
 * - Keep space clear, throw gently, eyes on partner’s chest
 */

const baseballPartnerDrills = [
  //done 1
  {
    id: 2160,
    name: 'Partner Toss and Catch Basics',
    categories: ['Partner', 'beginner'],
    sports: ['baseball'],
    difficulty: 'beginner',
    skill: 'Partner',
    points: 30,
    instructions:
      "Hey Super Catcher! Grab your best buddy for the ULTIMATE Partner Toss and Catch Challenge! Your mission, if you choose to accept it, is to become an unbeatable catching team! We're going to learn how to throw with laser-beam accuracy and catch like a superhero! Ready to become legends? Let's go!",
    timedInstructions: [
      {
        time: 0,
        text: "Alright team! Find your partner and stand facing them, about five big steps apart! Let's get started!",
      },
      {
        time: 6,
        text: "Get into your Catcher Stance! That means bend your knees a little, and get on the balls of your feet like you're about to pounce! Show me you're ready!",
      },
      {
        time: 12,
        text: 'Perfect! Now start bouncing! Light feet, quick feet! Bounce, bounce, bounce! Keep those feet awake!',
      },
      {
        time: 18,
        text: 'Decide who will be the thrower first! The other person is the catcher! Thrower, hold the ball. Catcher, get in your stance!',
      },
      {
        time: 25,
        text: "Okay throwers, we're going to learn a secret power move without the ball first! First, POINT your glove right at your partner's chest, like you're aiming a laser beam!",
      },
      {
        time: 33,
        text: 'Now, make a big T-shape with your arms! The glove arm is pointing forward, and the ball arm is way back! Show me that strong T-shape!',
      },
      {
        time: 40,
        text: "Last step! Take a big step forward with your front foot and pretend to throw! Point, T, Step and Throw! Let's practice that three times! Go!",
      },
      {
        time: 55,
        text: "Awesome! Now switch! Catcher, it's your turn to practice the power move! Thrower, you get in the ready stance! Show me Point, T, Step and Throw!",
      },
      {
        time: 70,
        text: "Okay, first thrower, grab the ball for real this time! Catcher, show me ready hands! Let's start with just the first step! Just POINT your glove and make an easy throw!",
      },
      {
        time: 80,
        text: "Let's do ten throws like that! After every catch, the new thrower points their glove and throws! Keep bouncing on your feet between every throw!",
      },
      {
        time: 95,
        text: 'Point and throw! Good! Get the ball back! Point and throw again! Keep your eye on the target!',
      },
      {
        time: 110,
        text: 'Keep it up! Bounce, bounce, bounce! Point that glove! Nice throw!',
      },
      {
        time: 125,
        text: "Okay, time to add the second part! Now you're going to Point AND make the T-shape! Point your glove, make the T with your arms, then throw!",
      },
      {
        time: 135,
        text: "Let's go! Ten more throws! Point, T, THROW! You'll feel more power now!",
      },
      {
        time: 150,
        text: 'Great job! Get the ball, get set, and do it again! Point! T! Throw! Stay bouncy!',
      },
      {
        time: 165,
        text: "Looking good! Are you remembering to make that big T-shape? It's the key to power!",
      },
      {
        time: 180,
        text: "Alright team, let's add the final piece of the puzzle! The big step! You're going to do all three parts! Ready? POINT, T, STEP AND THROW!",
      },
      {
        time: 192,
        text: "Let's do ten super-powered throws each! Put it all together and throw a perfect strike to your partner!",
      },
      {
        time: 210,
        text: 'Point, T, Step and Throw! Great! Now the other person goes! Point, T, Step and Throw! Back and forth!',
      },
      {
        time: 230,
        text: "Shuffle your feet while you wait for the throw! Don't stand still! Always be ready!",
      },
      {
        time: 250,
        text: "Five more perfect throws each! Come on! Laser-beam focus! Let's go!",
      },
      {
        time: 280,
        text: 'Keep it up! Point! T! Step! THROW! You guys look like pros!',
      },
      {
        time: 300,
        text: "FREEZE! Now let's focus on the CATCHER! Your turn to shine!",
      },
      {
        time: 308,
        text: "Catchers, listen close! The number one rule is to CATCH WITH TWO HANDS! Make a big basket for the ball so it can't escape!",
      },
      {
        time: 318,
        text: "The second rule is to WATCH THE BALL! Keep your eyes on it from the moment it leaves your partner's hand until it lands in your glove! Don't look away!",
      },
      {
        time: 330,
        text: 'Okay throwers, make nice, easy tosses to your catcher. Catchers, practice using two hands and watching the ball all the way in! Go!',
      },
      {
        time: 345,
        text: 'Two hands! Great catch! Get ready for the next one! Bounce on your feet!',
      },
      {
        time: 360,
        text: "Okay, new catching rule! If the ball is thrown to your side, don't just reach for it! MOVE YOUR FEET! Shuffle side to side to get your body in front of the ball!",
      },
      {
        time: 375,
        text: "Let's try it! Throwers, make a throw just to the left or right of your partner. Catchers, shuffle your feet and make the play! Go!",
      },
      {
        time: 395,
        text: 'Shuffle, shuffle, catch! Good! Throw it back! Get ready to shuffle again! Quick feet!',
      },
      {
        time: 415,
        text: "Yes! That's how you do it! Move your feet, then use two hands! Keep practicing!",
      },
      {
        time: 440,
        text: "Okay, now let's combine everything! Great throws and great catches! Let's just play catch for a minute. Remember all the rules! Go!",
      },
      {
        time: 460,
        text: 'Bounce on your feet! Point, T, Step and Throw! Shuffle your feet! Two-handed catch! You got this!',
      },
      {
        time: 500,
        text: "This looks amazing! You're a real team now! Keep that rhythm going! Throw, catch, throw, catch!",
      },
      {
        time: 540,
        text: "Keep it up! Don't get lazy! Every throw and every catch counts! Let's see ten more perfect ones!",
      },
      {
        time: 580,
        text: 'Five, four, three, two, one, and FREEZE!',
      },
      {
        time: 600,
        text: "Time for our first big challenge! It's called CATCHING STREAK! The goal is to see how many catches you can make IN A ROW without dropping the ball!",
      },
      {
        time: 615,
        text: 'Ready, set, GO! Count your catches out loud! One! Two! Keep the streak alive!',
      },
      {
        time: 630,
        text: 'If you drop it, you have to start over at zero! Oh no! Focus, focus, focus!',
      },
      {
        time: 660,
        text: 'Keep those feet bouncing! A ready body makes ready hands! How high can you get your score?',
      },
      {
        time: 700,
        text: "Come on, you can beat ten! Can you beat twenty? Let's go team!",
      },
      {
        time: 740,
        text: "Almost there, keep it going for ten more seconds! Don't drop it now!",
      },
      {
        time: 750,
        text: 'FREEZE! What was your high score? Awesome job!',
      },
      {
        time: 758,
        text: "Let's see if you can beat that score! Round two of Catching Streak starts NOW! Go, go, go! Count them out loud!",
      },
      {
        time: 780,
        text: "Faster throws this time! Quicker catches! Challenge yourselves! Let's see that score go up!",
      },
      {
        time: 820,
        text: 'Remember to move your feet to get in front of the ball! Good throws make for easy catches!',
      },
      {
        time: 860,
        text: "Thirty seconds left in this challenge! Keep that streak going! Don't give up!",
      },
      {
        time: 890,
        text: 'Five, four, three, two, one, TIME! Great work!',
      },
      {
        time: 900,
        text: 'Okay team, get ready for the MOVING TARGET challenge! One person is the Thrower, the other is the Mover!',
      },
      {
        time: 910,
        text: 'Movers, your job is to shuffle side to side! A few steps left, then a few steps right! Never stop moving! Throwers, your job is to throw the ball right to your moving partner!',
      },
      {
        time: 925,
        text: "Ready? Set? GO! Movers, start shuffling! Throwers, aim for the moving target! Let's see it!",
      },
      {
        time: 950,
        text: "This is tricky! Throwers, you might have to lead your target a little bit! Movers, keep your hands ready even when you're shuffling!",
      },
      {
        time: 980,
        text: 'Keep those feet moving! Shuffle, shuffle, catch! Throw it back! Shuffle, shuffle, catch!',
      },
      {
        time: 1020,
        text: "Let's see ten good catches on the move! Come on team!",
      },
      {
        time: 1050,
        text: 'Annnnd SWITCH ROLES! Quick, quick, quick! The Mover is now the Thrower! The Thrower is now the Mover!',
      },
      {
        time: 1060,
        text: "Ready? And GO! New mover, start shuffling! New thrower, let's see that laser accuracy!",
      },
      {
        time: 1090,
        text: 'Keep your eyes on your partner! Anticipate where they are going to be! This is amazing teamwork!',
      },
      {
        time: 1130,
        text: "Don't forget your good throwing form! Point, T, Step and Throw! Even when your target is moving!",
      },
      {
        time: 1170,
        text: 'Ten, nine, eight, seven, six, five, four, three, two, one, and FREEZE!',
      },
      {
        time: 1200,
        text: 'It is time for the FINAL CHALLENGE! The LIGHTNING ROUND! Everyone take two big steps back from your partner! Make the throw a little longer!',
      },
      {
        time: 1215,
        text: 'The goal is simple! Complete TWENTY perfect throws and catches as FAST as you can! This is all about speed and control! Ready... set... GO!',
      },
      {
        time: 1230,
        text: 'Count them out! One! Two! Three! Come on, faster! Four! Quick throws, quick catches!',
      },
      {
        time: 1260,
        text: "Don't stop bouncing! Hustle to get the ball if you drop it! Every second counts!",
      },
      {
        time: 1300,
        text: "Halfway there! That's ten! Let's see ten more! Super speed activated!",
      },
      {
        time: 1330,
        text: 'Fifteen! Five more to go! You can do it! Push, push, push!',
      },
      {
        time: 1350,
        text: 'TIME! Awesome job! Catch your breath for a second! Woo!',
      },
      {
        time: 1360,
        text: "But we are not done yet! Can you do it even FASTER? Let's find out! ONE MORE ROUND! Try to beat your last time!",
      },
      {
        time: 1375,
        text: 'Twenty more catches! The final countdown! On your marks... get set... GO GO GO!',
      },
      {
        time: 1400,
        text: "You know the drill! Explode with speed! Perfect throws! Perfect catches! Let's go!",
      },
      {
        time: 1440,
        text: "Don't let your arms get tired! Keep that perfect form! Point, T, Step and Throw!",
      },
      {
        time: 1480,
        text: 'Almost there! Final ten seconds! How many can you get? Go all out!',
      },
      {
        time: 1500,
        text: 'FREEZE! WOW! That was incredible! Amazing work, team!',
      },
      {
        time: 1515,
        text: 'Walk up to your partner and give them a super awesome high-five! You both were fantastic!',
      },
      {
        time: 1530,
        text: 'Today, you practiced perfect throws, you practiced two-handed catches, and you worked together like true champions!',
      },
      {
        time: 1545,
        text: 'Mission complete! You are now official Toss and Catch SUPERSTARS! Great job today!',
      },
    ],
    timeTotal: 1565,
    equipment: 'Soft ball or rolled socks, two gloves optional',
  },
  //done 1
  {
    id: 2161,
    name: 'Partner Grounder Roll and Scoop',
    categories: ['Partner', 'beginner'],
    sports: ['baseball'],
    difficulty: 'beginner',
    skill: 'Partner',
    points: 30,
    instructions:
      "Hey team! Grab your best buddy! It's time for a super fun ground ball mission! We're gonna learn to stop every ball like a real superstar. Get ready to scoop, roll, and have a blast together! Let's go!",
    timedInstructions: [
      {
        time: 0,
        text: "Get ready team! Find your partner and stand facing them! Let's become ground ball gobblers!",
      },
      {
        time: 5,
        text: "Make sure you have some space! We're going to be moving around! Start bouncing on your feet, let's go, let's go!",
      },
      {
        time: 10,
        text: 'First, we learn the SUPERHERO STANCE! Are you ready?',
      },
      {
        time: 15,
        text: "Get your feet nice and wide! Wider than your shoulders! Like you're a super strong sumo wrestler! Show me your wide feet!",
      },
      {
        time: 25,
        text: "Great! Now, bend your knees and stick your bottom out a little bit, like you're about to sit in a tiny chair! Keep bouncing!",
      },
      {
        time: 35,
        text: 'Perfect! Now for the most important part! The GATOR TRAP! Put your glove on the ground in front of you.',
      },
      {
        time: 45,
        text: "Put your other hand right on top of the glove, making a big alligator mouth! Get ready to chomp the ball! That's the Gator Trap!",
      },
      {
        time: 55,
        text: "Okay, let's practice! Stand up straight! And when I say GO, drop into your Superhero Stance with the Gator Trap! Ready... GO!",
      },
      {
        time: 65,
        text: "Awesome! Stand up again! Let's do it faster! Ready... GO!",
      },
      {
        time: 75,
        text: 'You got it! Keep bouncing, keep those feet ready! Time to use a ball!',
      },
      {
        time: 85,
        text: 'Partner One, you get the ball! Partner Two, you get in your awesome Superhero Stance! Glove down, Gator Trap ready!',
      },
      {
        time: 95,
        text: "Partner One, get ready to roll the ball on the ground, nice and smooth, right to your partner's glove! Here we go!",
      },
      {
        time: 105,
        text: "Roll it! Partner Two, trap that ball with your gator mouth! Don't let it escape! Good! Roll it back to your partner!",
      },
      {
        time: 120,
        text: "Let's do it again! Partner One, roll it! Partner Two, scoop it! Nice and easy! Roll it right back!",
      },
      {
        time: 135,
        text: "Keep going! Roll and trap! Make sure that glove is flat on the ground so the ball can't sneak under it!",
      },
      {
        time: 150,
        text: 'Good job team! Keep that gator mouth open until the ball is inside! CHOMP! Got it!',
      },
      {
        time: 165,
        text: "Okay! Time to switch! Quick, quick, quick! Partner Two, you're the roller now! Partner One, get in your Superhero Stance!",
      },
      {
        time: 180,
        text: 'Glove down! Bottom down! Ready for the roll! Partner Two, send it!',
      },
      {
        time: 190,
        text: 'Trap it, Partner One! Great job! Send it back nice and smooth!',
      },
      {
        time: 200,
        text: "Let's keep this going! Roll and trap, roll and trap! You guys are a great team!",
      },
      {
        time: 215,
        instruction:
          "Remember, watch the ball all the way into your glove! Don't look away!",
      },
      {
        time: 230,
        instruction:
          "Perfect! Keep those feet bouncing even when you're in your stance! Be ready for anything!",
      },
      {
        time: 245,
        instruction: "Okay, a few more! Let's see your best scoop yet! Go!",
      },
      {
        time: 260,
        instruction:
          'Amazing! Everybody stand up and shake it out! Wiggle your arms, wiggle your legs!',
      },
      {
        time: 270,
        instruction:
          "Now the ball is going to be tricky! It's not always rolled right to you! You have to move your feet!",
      },
      {
        time: 280,
        instruction:
          "Partner One, you're rolling first. Partner Two, get in your ready stance, but be ready to shuffle!",
      },
      {
        time: 290,
        instruction:
          "Partner One, this time, roll the ball a little bit to your partner's LEFT side. Not too far! Make 'em move!",
      },
      {
        time: 300,
        instruction:
          "Go! Roll it left! Partner Two, shuffle your feet to get in front of the ball, then do your Gator Trap! Don't reach, move your whole body!",
      },
      {
        time: 315,
        instruction:
          "Great shuffle! Let's do it again! Roll it to the left! Shuffle, shuffle, scoop!",
      },
      {
        time: 330,
        instruction:
          'Yes! Fast feet are the secret! Always try to get your body in front of the ball!',
      },
      {
        time: 345,
        instruction:
          "Okay, now let's go to the RIGHT side! Partner One, roll it to your partner's right!",
      },
      {
        time: 355,
        instruction:
          'Shuffle right! Get in front! Trap it! Awesome! Send it back!',
      },
      {
        time: 370,
        instruction:
          "Again to the right! Let's go! Move those feet! Be quicker than the ball!",
      },
      {
        time: 385,
        instruction:
          'Okay, switch roles! Fast switch! Partner Two is the roller, Partner One is the scooper!',
      },
      {
        time: 395,
        instruction:
          'Ready scooper? Feet bouncing! Roller, send one to the LEFT!',
      },
      {
        time: 405,
        instruction:
          'Shuffle and scoop! You got it! Now send one to the RIGHT!',
      },
      {
        time: 415,
        instruction:
          'Shuffle and scoop! Fantastic! Keep mixing it up! Left, then right, then maybe one down the middle!',
      },
      {
        time: 430,
        instruction:
          "Keep that scooper guessing! Move those feet, scooper! Don't let anything get past you!",
      },
      {
        time: 450,
        instruction:
          'Awesome work! Stand up, shake it out! Time for a new power move!',
      },
      {
        time: 460,
        instruction:
          "This is called the FUNNEL! After you trap the ball with your gator mouth, you're going to bring it right into your tummy, like a magnet is pulling it in!",
      },
      {
        time: 475,
        instruction:
          "So you scoop it, and right away, bring both hands to your chest. Scoop and Funnel! Let's try it.",
      },
      {
        time: 485,
        instruction:
          'Partner One, you roll first. Nice and straight. Partner Two, get ready to scoop and FUNNEL! Go!',
      },
      {
        time: 495,
        instruction:
          'Scoop! Now bring it to your tummy! Yes! That protects the ball! Roll it back!',
      },
      {
        time: 510,
        instruction:
          "Let's do it again! Scoop and Funnel! Make it one smooth move! It's like the ball is a hot potato, get it off the ground and into your hands fast!",
      },
      {
        time: 525,
        instruction:
          "Keep practicing! Scoop and Funnel! It's a super important move!",
      },
      {
        time: 540,
        instruction:
          'Okay, switch roles! Partner Two rolls, Partner One does the Scoop and Funnel!',
      },
      {
        time: 550,
        instruction:
          'Ready? Go! Roll it! Scoop it, funnel it! Perfect! Send it back!',
      },
      {
        time: 565,
        instruction:
          "Let's see it again! Faster this time! Scoop and Funnel! You look like a pro!",
      },
      {
        time: 580,
        instruction:
          'Keep up the great work! This is how you stop every single ground ball!',
      },
      {
        time: 595,
        instruction:
          'Awesome job, team! High-five your partner! Now get ready for a challenge!',
      },
      {
        time: 605,
        instruction:
          "It's time for a SPEED DRILL! This is the Lightning Round!",
      },
      {
        time: 612,
        instruction:
          'You and your partner will roll, scoop, and funnel back and forth as fast as you can for 30 seconds! Ready?',
      },
      {
        time: 620,
        instruction:
          'Get set... GO! Fast as you can! Roll, scoop, funnel, roll back! Quick quick quick!',
      },
      { time: 635, instruction: 'Ten more seconds! Come on, faster, faster!' },
      {
        time: 650,
        instruction:
          'TIME! Phew! Great hustle! Take a 15 second rest. Shake out your hands!',
      },
      {
        time: 665,
        instruction:
          'Get ready! Lightning Round two is coming! Can you go even faster?',
      },
      {
        time: 675,
        instruction:
          "Ready... GO GO GO! Faster than last time! Let's see that ball fly back and forth!",
      },
      {
        time: 690,
        instruction:
          "Don't get sloppy! Still use your good Superhero Stance! Keep it up!",
      },
      {
        time: 705,
        instruction:
          'TIME! YES! Awesome job! One more round to go! This is the final one!',
      },
      {
        time: 720,
        instruction:
          "This is for the championship! Give it everything you've got! Ready... GO!",
      },
      {
        time: 735,
        instruction:
          "SUPER SPEED! Let's see those hands move! You're a machine! Go, go, go!",
      },
      {
        time: 750,
        instruction:
          'AMAZING! Stop! High-five your partner! You crushed the Lightning Round!',
      },
      {
        time: 760,
        instruction:
          'Okay team, new challenge! The ball is going to your side now! We have to use a BACKHAND scoop!',
      },
      {
        time: 770,
        instruction:
          "It's like a backwards glove trap! Partner One, you're rolling. Partner Two, get in your ready stance.",
      },
      {
        time: 780,
        instruction:
          "Partner One, you're going to roll the ball to your partner's GLOVE side, so they have to reach ACROSS their body to get it.",
      },
      {
        time: 795,
        instruction:
          "Let's try it! Partner One, roll to the glove side. Partner Two, reach across, put your glove down on its side, and stop the ball! Then just toss it back.",
      },
      {
        time: 810,
        instruction:
          "Do that again! Reach across and stop! Good! It's a little tricky, so take your time!",
      },
      {
        time: 825,
        instruction:
          "Great! Now let's add the FLIP! After you stop it with your backhand, flip it back to your partner with your glove, like you're flipping a pancake!",
      },
      {
        time: 840,
        instruction:
          "Let's try! Partner One rolls, Partner Two does the backhand scoop and FLIP! Whoa! Awesome! Try it again!",
      },
      { time: 855, instruction: 'Backhand scoop and FLIP! You got it!' },
      {
        time: 870,
        instruction:
          "SWITCH SIDES! Quick switch! Now Partner Two rolls to Partner One's glove side. Partner One, you do the backhand scoop and flip! Let's go!",
      },
      {
        time: 885,
        instruction:
          'Reach across... scoop... and FLIP! Nice! Keep practicing!',
      },
      {
        time: 900,
        instruction:
          "This is a super tough move and you're doing great! A few more!",
      },
      { time: 915, instruction: 'Fantastic! Stand up and shake it out!' },
      {
        time: 925,
        instruction:
          'Time for the LONG ROLL challenge! Everybody, take five giant steps backwards from your partner! Go!',
      },
      {
        time: 935,
        instruction:
          "Whoa, you're far apart now! This means the roller has to roll it harder, and the scooper has to CHARGE to the ball! You have to run to it!",
      },
      {
        time: 950,
        instruction:
          'Partner One, you roll first! Give it a good, long roll! Partner Two, CHARGE! Run to the ball, get in your Gator Trap stance, and scoop it up!',
      },
      {
        time: 965,
        instruction:
          'Great hustle! Now roll it back long to your partner! They have to charge too!',
      },
      {
        time: 980,
        instruction:
          "Keep going! Charge the ball! Don't wait for it to come to you! Go get it! Let's see you run!",
      },
      {
        time: 995,
        instruction: 'Move those feet! Attack the ball! Scoop it up clean!',
      },
      {
        time: 1010,
        instruction:
          'You are both doing an amazing job! This is how you play like a big leaguer!',
      },
      {
        time: 1025,
        instruction:
          'Awesome hustle! Okay, take three giant steps back toward your partner. Back to normal distance.',
      },
      { time: 1040, instruction: 'Get ready for... the FINAL BOSS CHALLENGE!' },
      {
        time: 1050,
        instruction:
          'Partner One, you are the Ball Machine! Partner Two, you are The Wall! Nothing gets past The Wall!',
      },
      {
        time: 1060,
        instruction:
          'Ball Machine, you are going to roll balls one after another. Roll one to the left, one to the right, one in the middle, and one backhand! Wall, you have to stop them ALL! Ready?',
      },
      {
        time: 1075,
        instruction:
          'GO! Ball machine, start rolling! Left! Good! Now right! Good! Now middle! Awesome! Now backhand side!',
      },
      {
        time: 1090,
        instruction:
          'YOU ARE A WALL! Keep going! Ball Machine, mix them up and make it tricky!',
      },
      {
        time: 1105,
        instruction:
          'Keep shuffling those feet, Wall! You can do it! Ten more seconds!',
      },
      {
        time: 1115,
        instruction:
          'TIME! Shake it out! The Wall was amazing! Now, SWITCH ROLES!',
      },
      {
        time: 1125,
        instruction:
          "Partner Two is now the Ball Machine! Partner One is The Wall! Don't let anything get by you! Be a brick wall!",
      },
      { time: 1135, instruction: 'This is the FINAL ROUND! Get ready... GO!' },
      {
        time: 1145,
        instruction:
          "Ball Machine, roll 'em! Wall, stop 'em! Shuffle those feet! Get that glove down! You got this!",
      },
      {
        time: 1160,
        instruction:
          'Left! Right! Middle! Backhand! Go, go, go! You are unstoppable!',
      },
      {
        time: 1175,
        instruction: 'Five, four, three, two, one... YES! YOU DID IT!',
      },
      {
        time: 1185,
        instruction:
          'MISSION COMPLETE! High-five your partner, you are both Ground Ball Superstars! Great job today!',
      },
    ],
    timeTotal: 1190,
    equipment: 'Soft ball or rolled socks, two gloves optional',
  },
  //done 1
  {
    id: 2162,
    name: 'Partner Step and Throw Accuracy',
    categories: ['Partner', 'intermediate'],
    sports: ['baseball'],
    difficulty: 'intermediate',
    skill: 'Partner',
    points: 45,
    instructions:
      "Hello Superheroes! Get ready for the awesome Partner Throwing Challenge! You and your best buddy are on a mission to get super throwing powers! We're going to play fast, fun games to make your throws straight as a laser beam! Let's see who will be the champion!",
    timedInstructions: [
      {
        time: 0,
        text: "Alright team! Grab your soft ball or sock ball, and find a partner! Let's get started!",
      },
      {
        time: 10,
        text: 'Okay! Stand facing your partner, and take five big steps away from each other! Five, four, three, two, one! Perfect!',
      },
      {
        time: 20,
        text: "First, let's learn the Ready Rocket Stance! Stand with your feet about as wide as your shoulders, and bend your knees just a little bit, like you're about to blast off!",
      },
      {
        time: 35,
        text: "Now, let's practice! Get into your Ready Rocket Stance! And bounce on your feet! Bounce, bounce, bounce! Keep those superhero feet moving!",
      },
      {
        time: 50,
        text: 'Great! Now FREEZE in your stance! Are your knees bent? Are you ready for action? Awesome!',
      },
      {
        time: 60,
        text: 'Next up is the Train Track Grip! Hold the ball and find the seams that look like train tracks. Put two fingers right across those tracks!',
      },
      {
        time: 75,
        text: 'Show your partner your Train Track Grip! Now hide it! Now show me! Now hide it! Keep your hand strong but not too tight!',
      },
      {
        time: 90,
        text: "Let's put it together! Get in your Ready Rocket Stance, and hold the ball with your Train Track Grip! Point your body sideways, so your glove shoulder is pointing at your partner! You should look like a surfer on a surfboard!",
      },
      {
        time: 110,
        text: "Okay, now for the throwing action, but no throwing yet! First, make a big letter T with your arms! Your throwing arm goes back, and your glove arm points right at your partner's chest! Like you're aiming a laser!",
      },
      {
        time: 130,
        text: "Let's practice that! Ready Rocket Stance... Surfer Body... Make a T and AIM! Hold it! And relax! Do it again! Make a T and AIM! And relax! Keep bouncing on your feet!",
      },
      {
        time: 150,
        text: "Now add the step! When you aim, take a BIG step with your front foot, pointing your toes right at your partner! We call this the SUPERHERO STEP! Let's try it! Aim and STEP! Back to start! Aim and STEP! Back to start!",
      },
      {
        time: 170,
        text: "Now the last part of the motion! After you step, pretend to throw and let your throwing arm swing all the way across your body, like you're giving your other knee a high-five! Whoosh!",
      },
      {
        time: 190,
        text: "Let's do the whole thing in slow motion! NO THROWING! Ready! Surfer Body! Make a T! Superhero Step! And High-Five your knee! WHOOSH! Awesome! Let's do it again, a little faster!",
      },
      {
        time: 210,
        text: "Okay, team, it's time for our first real throws! Let's get close again, just three big steps apart! Super close!",
      },
      {
        time: 230,
        text: 'The person with the ball gets ready! Remember the steps! Surfer Body, Make a T, Superhero Step, and throw a soft, easy throw right to your partner! Catcher, make a big target with your hands!',
      },
      {
        time: 250,
        text: "Ready, set, THROW! Nice! Catcher, now it's your turn! Get set! Ready, set, THROW! Keep going back and forth! Soft and easy throws!",
      },
      {
        time: 270,
        text: "Don't forget to point your front foot! It tells the ball where to go! Point it right at your partner! Keep shuffling your feet while you wait for the ball!",
      },
      {
        time: 290,
        text: 'Catchers, use two hands! Make your hands into a big alligator mouth that chomps the ball! CHOMP! Watch it all the way in!',
      },
      {
        time: 310,
        text: "Keep it up! Let's do five more perfect throws each! Five! Four! Three! Two! One! Great job!",
      },
      {
        time: 340,
        text: "Okay! Time for a SPEED DRILL CHALLENGE! Stay close! Don't move back!",
      },
      {
        time: 350,
        text: 'The mission is to make as many good catches as you can in one minute! Throws must be soft and accurate! If you drop it, get it fast and keep going! Are you ready?!',
      },
      {
        time: 370,
        text: "Ready, set, GO! One minute on the clock! Go, go, go! Quick throws! Quick catches! Use your superhero step! Two hands to catch! Hustle, hustle, hustle! Keep bouncing! You're halfway there! Thirty more seconds! Don't slow down! Faster! Faster! Ten, nine, eight, seven, six, five, four, three, two, one, TIME'S UP!",
      },
      {
        time: 430,
        text: 'Whew! Awesome job! High-five your partner! Now, take three more BIG steps back! So you are about eight steps apart now! The throws get a little longer!',
      },
      {
        time: 445,
        text: "Now we need a little more power! When you make your T-shape, really reach back! Then, when you throw, throw a straight laser beam to your partner's chest!",
      },
      {
        time: 460,
        text: "Let's try it! Remember all the steps! Surfer body, make a T, superhero step, and throw a laser beam! Go for it! Back and forth!",
      },
      {
        time: 480,
        text: 'Looking good! Make sure your glove arm is aiming! If your aim is wiggly, your throw will be wiggly! Point that glove laser right at the target!',
      },
      {
        time: 500,
        text: 'Keep going! Throw after throw! Catcher, give your partner a great target to aim for! Stand tall and proud in your Ready Rocket Stance!',
      },
      {
        time: 525,
        text: "Let's focus on that follow-through! After you throw, let your arm swing all the way across your body. That's where the power comes from! WHOOSH!",
      },
      {
        time: 550,
        text: "Ten more laser throws each! I want to see straight lines! No floppy rainbow throws! Let's go! Ten! Nine! Eight! Keep it up! Seven! Six! Five! Almost there! Four! Three! Two! Last one! ONE!",
      },
      {
        time: 580,
        text: "Fantastic work! Time for our next game! It's the BULLSEYE ACCURACY CHALLENGE!",
      },
      {
        time: 595,
        text: "Here's how you play! The catcher's chest is the bullseye! If the thrower hits the catcher anywhere on their body, that's one point! If the catcher catches it right in their hands without moving their feet, that's THREE points for a bullseye!",
      },
      {
        time: 615,
        text: 'First person to get to 15 points wins the round! Keep your own score! Catcher, you have to be honest! Tell them if it was one point or three points! Ready?',
      },
      {
        time: 630,
        text: "BULLSEYE CHALLENGE... BEGIN! Go for the three points! Aim small, miss small! Use that superhero step to guide the ball! How many points do you have? Keep track! Catcher, be a statue! Don't move your feet! Make the thrower get the bullseye! Come on, you can do it! Focus! Laser beam throws only! Are you close to 15 points? Keep going!",
      },
      {
        time: 750,
        text: 'Keep playing! We have one more minute in the Bullseye Challenge! Get those last points! Go, go, go!',
      },
      {
        time: 765,
        text: 'And... FREEZE! Who won? Awesome job, both of you! High-five your partner again! You are becoming accuracy masters!',
      },
      {
        time: 780,
        text: 'Now for a new skill! The MOVING TARGET! This is tricky, so listen close! Take two more big steps back. You should be pretty far apart now!',
      },
      {
        time: 795,
        text: "Here's how it works. Catcher, right before your partner throws, you are going to take one big, quick shuffle step to the left or to the right!",
      },
      {
        time: 810,
        text: 'Thrower, your job is to see where your partner moves, and throw the ball to where they ARE, not where they were! You have to lead the target!',
      },
      {
        time: 830,
        text: "Let's try it slowly. Catcher, get ready! And... SHUFFLE LEFT! Thrower, see them? Now, step and throw to their left side! Go!",
      },
      {
        time: 850,
        text: 'Nice! Now the other person throws! Catcher, get ready! And... SHUFFLE RIGHT! Thrower, adjust your aim and throw to the right! Go!',
      },
      {
        time: 870,
        text: 'You got it! Keep going back and forth! Catcher, you choose which way to shuffle! Keep the thrower guessing! Shuffle left, shuffle right! Keep your feet moving!',
      },
      {
        time: 890,
        text: 'Throwers, this is tough but you can do it! Remember to step towards your new target! If they move left, you step a little to the left! Let your body help you aim!',
      },
      {
        time: 915,
        text: "Let's keep practicing the moving target! This is how the real pros do it! Shuffle and throw! Shuffle and catch! Keep a good rhythm going!",
      },
      {
        time: 940,
        text: "Five more moving target throws each! Let's see your best ones yet! Five! Four! Three! Two! And one! Amazing!",
      },
      {
        time: 960,
        text: 'Okay superheroes! It is time for the FINAL SUPERHERO SPEED DRILL!',
      },
      {
        time: 970,
        text: 'For this challenge, you have 90 seconds to get as many moving target catches as you can! Catcher, you must shuffle every single time! Thrower, you have to be fast and accurate!',
      },
      {
        time: 985,
        text: "The final challenge is ON! Ready, set, GO! Go, go, go! Shuffle and throw! Hustle for the ball if you miss! Ninety seconds of non-stop action! Let's see your power! Let's see your speed! Keep those feet moving! You're doing great! One minute left! Don't stop now! Push it! Hard throws! Quick shuffles! Thirty seconds! Faster! Faster! Go all out! Ten, nine, eight, seven, six, five, four, three, two, ONE! TIME IS UP!",
      },
      {
        time: 1075,
        text: 'YES! You did it! Walk to your partner and give them a super awesome high-five! You both were amazing! You are now official Throwing Accuracy Superheroes! Great, great job today!',
      },
    ],
    timeTotal: 1095,
    equipment: 'Soft ball or rolled socks, two gloves optional',
  },
  //done 1
  {
    id: 2163,
    name: 'Partner Quick Hands Challenge',
    categories: ['Partner', 'intermediate'],
    sports: ['baseball'],
    difficulty: 'intermediate',
    skill: 'Partner',
    points: 45,
    instructions:
      "Get ready for the Quick Hands Challenge with your partner! We're going to play a super fun game to see who has the fastest hands in the world! Grab a soft ball or even a pair of rolled-up socks. Your mission is to catch and throw faster than a superhero! No boring stuff, just pure action. Let's go, go, go!",
    timedInstructions: [
      {
        time: 0,
        text: "Hello super-athletes! Welcome to the Partner Quick Hands Challenge! Find your partner and get ready to play! Make sure you have a soft ball or a rolled-up pair of socks. Let's do this!",
      },
      {
        time: 15,
        text: "Face your partner! Get about ten big steps away from each other. Perfect! Now, let's learn the Superhero Stance! Feet shoulder-width apart, knees bent like you're about to spring into action! Awesome!",
      },
      {
        time: 30,
        text: "Show me your hands! Bring them up in front of you like you're ready to catch anything! We call this your guard! Keep bouncing on the balls of your feet, stay light, stay ready! Bounce, bounce, bounce!",
      },
      {
        time: 45,
        text: "Okay, first challenge! The Quick Toss! Partner one, toss the ball right to your partner's chest. Partner two, catch it with two hands, bring it right to your chest, and toss it right back! Let's go!",
      },
      {
        time: 60,
        text: 'Keep it going! Toss, catch, chest, toss! Just like that! Be super quick! The floor is hot lava, so keep those feet moving! Bounce, bounce, bounce!',
      },
      {
        time: 90,
        text: "Don't forget your Superhero Stance! Are your knees bent? Is your back straight? Are your eyes on the ball? Yes! You look like champions!",
      },
      {
        time: 120,
        text: "Faster now! Let's speed it up! Quick hands, quick hands! See how many you can do without dropping it. Let's count them together! One! Two! Three! Keep going!",
      },
      {
        time: 150,
        text: 'Great rhythm! Keep shuffling your feet left and right while you wait for the toss. Never stand still! Always be ready to move! Shuffle, shuffle, catch, throw!',
      },
      {
        time: 180,
        text: "Okay, let's make this a challenge! For the next thirty seconds, see who has the softest, fastest hands! Ready... set... GO! Toss, catch, toss, catch! Don't let it touch the ground!",
      },
      {
        time: 210,
        text: 'Ten more seconds! Go, go, go! Faster! Five, four, three, two, one! FREEZE! Amazing job! Shake your arms out! Wiggle your fingers!',
      },
      {
        time: 240,
        text: "Keep bouncing on your feet, don't stop moving! We're just getting started. Check your partner, are they ready? Give them a thumbs up!",
      },
      {
        time: 270,
        text: "Let's go again, same thing! But this time, I want you to make a little 'swoosh' sound every time you throw! Ready? GO! Swoosh! Catch! Swoosh! Catch! Make it fun!",
      },
      {
        time: 300,
        text: "Awesome work! Keep that energy up! Knees bent, feet moving, eyes on your target! You're doing great! Three, two, one, and stop! High five the air!",
      },
      {
        time: 330,
        text: "New challenge! The Shuffle Toss! It's time to move your feet! Partner one, you're shuffling first! Partner two, you stay in your Superhero Stance!",
      },
      {
        time: 345,
        text: "Here's how we do it! You're going to slide your feet sideways like a crab, don't cross them! Take one big shuffle to the side, and then throw to your partner! Then shuffle back! Ready?",
      },
      {
        time: 360,
        text: "Partner one, shuffle to your right! Throw! Shuffle back to the middle! Good! Now shuffle to your left! Throw! Shuffle back! Partner two, you just catch and throw it right back to the middle. Let's go!",
      },
      {
        time: 390,
        text: "Shuffle, throw, shuffle back! Other way! Shuffle, throw, shuffle back! Keep your feet quick and light! Don't let them get stuck in mud! Quick feet, quick feet!",
      },
      {
        time: 420,
        text: 'Stay low in your Superhero Stance while you shuffle! It gives you power! You got this! Keep that ball flying!',
      },
      {
        time: 450,
        text: 'Look at you go! A shuffling, throwing machine! Fifteen more seconds for partner one! Make every shuffle super sharp! Go, go, go!',
      },
      {
        time: 480,
        text: "Three, two, one, and SWITCH! Great job partner one! Shake it out! Now it's partner two's turn to be the crab! Partner one, you're the target now!",
      },
      {
        time: 510,
        text: "Ready partner two? Let's see your shuffle! Shuffle right, THROW! Shuffle back! Shuffle left, THROW! Shuffle back! Let's see that energy!",
      },
      {
        time: 540,
        text: "Keep your eyes on your partner even when you're shuffling! Try to throw it right to their chest every single time! Be a perfect partner!",
      },
      {
        time: 570,
        text: "That's it! Quick feet, fast hands! You're a baseball superstar in training! Keep up the awesome work! Don't slow down!",
      },
      {
        time: 600,
        text: "Final thirty seconds for partner two! Let's see your best shuffles yet! Super fast, super clean! GO! Shuffle-throw! Shuffle-throw! Faster!",
      },
      {
        time: 630,
        text: 'Ten seconds left! Push it! Five, four, three, two, one, and TIME! Fantastic! Everybody stop and give your partner a giant air high-five!',
      },
      {
        time: 660,
        text: 'Quick water break! You have twenty seconds to grab a super fast sip of water! The countdown is on! Twenty, nineteen, eighteen... get back to your spot! ...ten, nine, eight...',
      },
      {
        time: 690,
        text: "And we're back! Time for the Pop-Up Throw! This one is super fun! Partner one, you're popping up first! Partner two, you're the thrower!",
      },
      {
        time: 705,
        text: 'Partner one, get into a low squat like a frog ready to leap! Hands ready! Partner two, you stand tall in your Superhero Stance.',
      },
      {
        time: 720,
        text: "Here's the mission! Partner two, you're going to toss the ball. As it comes, partner one, you EXPLODE up from your squat, catch the ball, and throw it back! Then go right back down into your frog squat! Ready? GO!",
      },
      {
        time: 750,
        text: "Down low... POP UP and catch! Throw! Back down low! Just like that! Be powerful! Imagine you're launching a rocket every time you stand up!",
      },
      {
        time: 780,
        text: "Partner two, make your throws nice and easy for your partner to catch. You're a team! Help them succeed! Aim for their face, but gently!",
      },
      {
        time: 810,
        text: 'Keep going partner one! Feel the power in your legs! Explode up! Stay low in that squat until the ball is thrown. You can do it!',
      },
      {
        time: 840,
        text: 'Thirty more seconds of pop-ups! Every one faster than the last! Pop! Catch! Throw! Squat! Go, go, go!',
      },
      {
        time: 870,
        text: "Three, two, one, and SWITCH! Amazing work! Shake those legs out! Now it's partner two's turn to be the frog! Partner one, get ready to throw!",
      },
      {
        time: 900,
        text: "Okay partner two, get down in that super low frog squat! Hands ready! Partner one, remember to make good, easy throws! Let's begin!",
      },
      {
        time: 930,
        text: "POP UP and catch! Throw! Get right back down! Awesome! That's how you do it! Be quick, be strong!",
      },
      {
        time: 960,
        text: "Think about being a spring! You're coiled up tight in the squat, and then... BOING! You spring up to catch the ball! Stay bouncy!",
      },
      {
        time: 990,
        text: "You're doing amazing! This move makes you super athletic! Keep breathing! Don't hold your breath! Let's go!",
      },
      {
        time: 1020,
        text: "Final fifteen seconds! Let's see five more perfect pop-ups! One! Two! Three! Four! Five! YES! Time! Woo! You guys are rocking this!",
      },
      {
        time: 1050,
        text: "Okay, new skill! The Glove-Side and Backhand Challenge! Everyone, pretend you're wearing a baseball glove on your non-throwing hand. If you throw with your right hand, the glove is on your left!",
      },
      {
        time: 1070,
        text: "Your glove side is the easy side to catch on. Your backhand side is the other side, the tricky one! We're going to practice both! Partner one, you're throwing first! Partner two, get ready to catch!",
      },
      {
        time: 1080,
        text: "Partner one, your first throw is to your partner's GLOVE side. That's their easy side! Go! Now partner two, throw it back to the middle.",
      },
      {
        time: 1100,
        text: 'Now partner one, throw to their BACKHAND side! The tricky side! Make them reach! Go! And partner two, throw it back. Good!',
      },
      {
        time: 1120,
        text: "Let's get a rhythm! Throw to the glove side! Throw back! Throw to the backhand side! Throw back! Partner two, you have to move your feet to get in front of the ball!",
      },
      {
        time: 1150,
        text: "Quick feet, partner two! Don't just reach with your arm, move your whole body! Shuffle your feet to the ball! That's the secret!",
      },
      {
        time: 1180,
        text: "Partner one, you're the boss! Keep switching it up! Glove side! Backhand! Keep your partner guessing and moving! Be a tricky pitcher!",
      },
      {
        time: 1210,
        text: "Ten more seconds! Make them work for it! Quickest feet win! Three, two, one, and SWITCH! Awesome catching! Now it's your turn to throw!",
      },
      {
        time: 1230,
        text: "Partner two, you're the thrower! Partner one, show me you're ready to move! Bounce on your feet! Superhero Stance ready!",
      },
      {
        time: 1245,
        text: 'Ready? Go! Partner two, throw to the glove side! Good catch! Now throw to the backhand side! Yes! Get that rhythm going!',
      },
      {
        time: 1270,
        text: "Partner one, show me those fast feet! Shuffle to the ball! Get your body behind the catch! Don't be lazy with your feet!",
      },
      {
        time: 1300,
        text: "Eyes on the ball all the way until it's in your hands! Watch it, watch it, watch it... CATCH! Perfect!",
      },
      {
        time: 1330,
        text: "Keep it up! You're both doing an amazing job! This is how you get super quick hands! One more minute of this, let's go!",
      },
      {
        time: 1360,
        text: 'Final fifteen seconds! Fastest throws, fastest feet! Go all out! Glove side, backhand, glove side, backhand! Go, go, go!',
      },
      {
        time: 1390,
        text: 'Five, four, three, two, one, and TIME! Incredible work! Shake your arms, shake your legs, take a deep breath!',
      },
      {
        time: 1410,
        text: "Okay team! It's time for the final challenge! The SUPER SPEED DRILL! I'm going to call out a move, and you and your partner have to do it as fast as you can! Listen carefully!",
      },
      {
        time: 1430,
        text: 'Both of you will be moving and throwing! When I say a move, the person with the ball does it! Ready? The first call is... QUICK TOSS! Go! Just toss back and forth fast!',
      },
      {
        time: 1450,
        text: 'Keep bouncing! Next call... SHUFFLE LEFT AND THROW! The thrower shuffles left and throws! Good!',
      },
      {
        time: 1470,
        text: 'Next... POP-UP CATCH! The catcher gets low and pops up to catch! Awesome!',
      },
      {
        time: 1490,
        text: 'Now... GLOVE SIDE THROW! Thrower aims for the glove side! Yes!',
      },
      {
        time: 1510,
        text: "BACKHAND SIDE THROW! Aim for the tricky side! Great work! Let's mix them up now, get ready!",
      },
      {
        time: 1530,
        text: 'POP-UP CATCH! Go! Now, SHUFFLE RIGHT AND THROW! Quick! QUICK TOSS! BACKHAND THROW! GLOVE SIDE THROW! Keep up!',
      },
      {
        time: 1560,
        text: "Thirty second lightning round! How many perfect catches can you and your partner make in thirty seconds? I'll call the moves, you just catch and throw! Ready... GO! Quick toss! Shuffle Left! Pop-up Catch! Glove Side! Backhand! Quick Toss! Shuffle Right!",
      },
      {
        time: 1590,
        text: "Halfway there! Keep going! Don't drop it! Faster! Pop-Up! Glove Side! Quick Toss! Five, four, three, two, one! STOP! How many did you get? Awesome job!",
      },
      {
        time: 1620,
        text: 'We have one more round in us! This is for the championship! Can you beat your score? Get ready to be even faster! Deep breath... and... GO!',
      },
      {
        time: 1650,
        text: "BACKHAND! POP-UP CATCH! SHUFFLE LEFT! QUICK TOSS! SHUFFLE RIGHT! GLOVE SIDE! Let's go, let's go! Total focus!",
      },
      {
        time: 1680,
        text: "Don't get tired now! This is where champions are made! Move those feet! Watch that ball! Communicate with your partner! You're a team!",
      },
      {
        time: 1710,
        text: "Ten seconds left! Empty the tank! Everything you've got! Go, go, go! Five, four, three, two, one! AND THAT'S IT! YOU DID IT!",
      },
      {
        time: 1740,
        text: 'AMAZING JOB! Give your partner a real high-five! You both were incredible today! You completed the Partner Quick Hands Challenge!',
      },
      {
        time: 1770,
        text: 'Look at your hands! They are officially... SUPER QUICK! Great work today, athletes! See you next time for another challenge!',
      },
      {
        time: 1800,
        text: '',
      },
    ],
    timeTotal: 1800,
    equipment: 'Soft ball or rolled socks, two gloves optional',
  },
  //done 1
  {
    id: 2164,
    name: 'Partner Pop Fly Call and Catch',
    categories: ['Partner', 'advanced'],
    sports: ['baseball'],
    difficulty: 'advanced',
    skill: 'Partner',
    points: 45,
    instructions:
      "Get ready for an awesome baseball adventure! In this super fun game, you and your partner will become superstar catchers! We are going to learn how to catch pop flies like the pros. Get ready to toss, call it loud, and make amazing catches! Let's play!",
    timedInstructions: [
      {
        time: 0,
        text: 'Hello Superstars! Welcome to the Pop Fly Call and Catch Challenge!',
      },
      {
        time: 5,
        text: 'Find your partner and stand about ten big steps away from each other.',
      },
      {
        time: 10,
        text: "You'll need one soft ball. If you don't have one, a pair of rolled-up socks works great!",
      },
      {
        time: 16,
        text: 'The person with the ball is the Tosser! The other person is the Catcher! Decide who is who!',
      },
      {
        time: 23,
        text: "Okay, let's get started in three, two, one, GO!",
      },
      {
        time: 30,
        text: "First, let's all learn the Catcher's Ready Stance! This is our superhero pose!",
      },
      {
        time: 37,
        text: 'Put your feet a little wider than your shoulders! Perfect!',
      },
      {
        time: 42,
        text: "Now, bend your knees like you're about to jump super high!",
      },
      {
        time: 47,
        text: "Put your hands up in front of you, open and ready, like you're holding a giant pizza!",
      },
      {
        time: 54,
        text: "This is your Ready Stance! Freeze! Don't move a muscle! Hold it!",
      },
      {
        time: 62,
        text: 'And relax! Shake it out! Wiggle your arms and legs!',
      },
      {
        time: 68,
        text: "Let's try it again! Everyone, Ready Stance... GO! Hold it steady!",
      },
      {
        time: 78,
        text: 'Awesome! Now, start bouncing on the balls of your feet! Light feet, light feet!',
      },
      {
        time: 85,
        text: 'Okay Catcher, stay in your stance and keep bouncing! Tosser, you can stand up for a second.',
      },
      {
        time: 93,
        text: 'Catcher, keep bouncing! Shuffle your feet left and right! Stay ready!',
      },
      {
        time: 105,
        text: 'Next up is the most important part of catching! Calling the ball!',
      },
      {
        time: 111,
        text: "When your partner tosses it, you have to yell loud and proud so everyone knows it's yours!",
      },
      {
        time: 118,
        text: "You are going to yell... 'I GOT IT!'",
      },
      {
        time: 123,
        text: "Let's practice! Catcher, get in your Ready Stance. On the count of three, give me your loudest yell!",
      },
      {
        time: 130,
        text: 'One... two... THREE!',
      },
      {
        time: 134,
        text: "Whoa! That was loud! Let's do it again, even louder this time!",
      },
      {
        time: 140,
        text: 'Ready? One... two... THREE!',
      },
      {
        time: 144,
        text: "Perfect! Now, Tosser, it's your turn to practice the call! Let's hear it!",
      },
      {
        time: 150,
        text: 'One... two... THREE!',
      },
      {
        time: 154,
        text: 'Fantastic! You both have your superstar call! Okay, Catcher is up first! Get in your ready stance!',
      },
      {
        time: 165,
        text: 'Alright, Tossers! Your turn to shine! Your job is to make a nice, easy, gentle toss.',
      },
      {
        time: 173,
        text: "We're not throwing a fastball! We're tossing it up high and soft, like a fluffy cloud.",
      },
      {
        time: 180,
        text: 'Hold the ball and swing your arm underhand, just popping it straight up so it lands near your Catcher.',
      },
      {
        time: 188,
        text: 'Tosser, do one gentle practice toss to yourself. Up... and down. Perfect.',
      },
      {
        time: 195,
        text: 'Okay team! Time to put it together! Catcher, get in your Ready Stance!',
      },
      {
        time: 201,
        text: "Tosser, get ready to toss. Here's the mission! Tosser, you toss. Catcher, you yell 'I GOT IT!'",
      },
      {
        time: 208,
        text: "We are not catching yet! Just calling! We'll do it five times! Ready?",
      },
      {
        time: 215,
        text: "Toss ONE! Catcher, yell 'I GOT IT!'",
      },
      {
        time: 220,
        text: "Great! Keep bouncing Catcher! Toss TWO! Yell 'I GOT IT!'",
      },
      {
        time: 226,
        text: "Awesome call! Keep those feet moving! Toss THREE! Yell 'I GOT IT!'",
      },
      {
        time: 232,
        text: "Super loud! Two more! Toss FOUR! Yell 'I GOT IT!'",
      },
      {
        time: 238,
        text: "Last one! Make it your best one! Toss FIVE! Yell 'I GOT IT!'",
      },
      {
        time: 244,
        text: 'Amazing job! Give your partner a high five! Now, switch jobs!',
      },
      {
        time: 250,
        text: "The Catcher becomes the Tosser, and the Tosser becomes the Catcher! Let's go!",
      },
      {
        time: 257,
        text: "New Catcher, get in your Ready Stance! We're doing five practice calls! Ready?",
      },
      {
        time: 265,
        text: "Toss ONE! Yell 'I GOT IT!'",
      },
      {
        time: 270,
        text: "Yes! Keep bouncing! Toss TWO! Yell 'I GOT IT!'",
      },
      {
        time: 276,
        text: "Great job! Shuffle those feet! Toss THREE! Yell 'I GOT IT!'",
      },
      {
        time: 282,
        text: "Louder! You got this! Toss FOUR! Yell 'I GOT IT!'",
      },
      {
        time: 288,
        text: "One more! Best one yet! Toss FIVE! Yell 'I GOT IT!'",
      },
      {
        time: 294,
        text: 'Incredible! You are both ready for the main event! Time to Call it and Catch it!',
      },
      {
        time: 305,
        text: 'Catcher, get in your Ready Stance! Knees bent, hands ready!',
      },
      {
        time: 311,
        text: 'Tosser, remember, a nice gentle toss right to your partner.',
      },
      {
        time: 316,
        text: "The game is simple: Tosser tosses. Catcher yells 'I GOT IT!' and then catches the ball with two soft hands.",
      },
      {
        time: 325,
        text: "Let's see if you can get five in a row! Ready... TOSS ONE!",
      },
      {
        time: 331,
        text: 'Nice catch! Give the ball back to the tosser. Catcher, keep bouncing on your feet!',
      },
      {
        time: 338,
        text: 'Ready for number two! TOSS TWO!',
      },
      {
        time: 344,
        text: 'Awesome catch! Give it back! Shuffle left and right Catcher! Be ready for anything!',
      },
      {
        time: 352,
        text: 'Here we go! TOSS THREE!',
      },
      {
        time: 358,
        text: "You're a natural! Ball back! Two more to go! You can do it! Stay low!",
      },
      {
        time: 366,
        text: 'Get ready... TOSS FOUR!',
      },
      {
        time: 372,
        text: 'Fantastic! One more! This is for the championship!',
      },
      {
        time: 378,
        text: 'TOSS FIVE!',
      },
      {
        time: 384,
        text: 'YOU DID IT! FIVE IN A ROW! Awesome work! Now, switch jobs!',
      },
      {
        time: 392,
        text: "Let's see if the new Catcher can get five in a row! Get ready!",
      },
      {
        time: 400,
        text: "Let's start! TOSS ONE!",
      },
      {
        time: 406,
        text: 'Great catch! Send it back! Keep those feet bouncing!',
      },
      {
        time: 412,
        text: 'Here it comes! TOSS TWO!',
      },
      {
        time: 418,
        text: 'Way to watch the ball! Give it back! Stay low in your stance!',
      },
      {
        time: 425,
        text: 'Get set... TOSS THREE!',
      },
      {
        time: 431,
        text: 'Yes! Two more! You got this!',
      },
      {
        time: 437,
        text: 'Ready... TOSS FOUR!',
      },
      {
        time: 443,
        text: 'Amazing! One last catch! Make it a great one!',
      },
      {
        time: 449,
        text: 'TOSS FIVE!',
      },
      {
        time: 455,
        text: 'PERFECT! FIVE FOR FIVE! You guys are superstars!',
      },
      {
        time: 462,
        text: 'Great job team! Time for a new challenge!',
      },
      {
        time: 468,
        text: "We are going to do another round of five catches each. But this time, it's tougher!",
      },
      {
        time: 475,
        text: 'After each catch, the Catcher has to do three jumping jacks before giving the ball back! Ready Catcher?',
      },
      {
        time: 485,
        text: "Okay Tosser, let's go! TOSS ONE!",
      },
      {
        time: 490,
        text: 'Great catch! Now three jumping jacks! One, two, three! Now give the ball back!',
      },
      {
        time: 498,
        text: 'Stay bouncy Catcher! Here comes the next one! TOSS TWO!',
      },
      {
        time: 504,
        text: 'Nice! Three jumping jacks! Go, go, go! One, two, three! Ball back!',
      },
      {
        time: 512,
        text: 'Keep that energy up! TOSS THREE!',
      },
      {
        time: 518,
        text: 'Awesome! Quick jumping jacks! One, two, three! Give it back!',
      },
      {
        time: 525,
        text: 'Two left! You can do it! TOSS FOUR!',
      },
      {
        time: 531,
        text: "You got it! Jumping jacks! One, two, three! Let's go!",
      },
      {
        time: 538,
        text: 'Last one for this round! TOSS FIVE!',
      },
      {
        time: 544,
        text: 'Incredible! Finish with your jumping jacks! One, two, three! High five!',
      },
      {
        time: 552,
        text: 'Okay, switch places! New Catcher, New Tosser! Time for your jumping jack challenge!',
      },
      {
        time: 560,
        text: "Get in your ready stance! Let's do five! TOSS ONE!",
      },
      {
        time: 566,
        text: 'Nice grab! Three jumping jacks! One, two, three! Ball back to the Tosser!',
      },
      {
        time: 574,
        text: 'Stay low, stay ready! TOSS TWO!',
      },
      {
        time: 580,
        text: "Yes! Quick jacks! One, two, three! Let's go!",
      },
      {
        time: 587,
        text: 'You are doing great! Keep it up! TOSS THREE!',
      },
      {
        time: 593,
        text: 'Perfect! Jumping jacks! One, two, three! Hustle!',
      },
      {
        time: 600,
        text: 'Only two more! TOSS FOUR!',
      },
      {
        time: 606,
        text: "You're a machine! Quick jacks! One, two, three! And back!",
      },
      {
        time: 613,
        text: 'Last one! Make it your best! TOSS FIVE!',
      },
      {
        time: 619,
        text: 'Amazing! Finish strong! One, two, three! Great job!',
      },
      {
        time: 628,
        text: 'Wow, you guys are amazing at catching the ball when it comes right to you!',
      },
      {
        time: 634,
        text: "But what if it's tossed a little to the side? We need to move our feet!",
      },
      {
        time: 640,
        text: "We are going to learn 'Scuttle Steps'! It sounds funny and it's super useful!",
      },
      {
        time: 647,
        text: 'Everyone, get in your Ready Stance. Now, without crossing your feet, take quick, choppy little side steps to your right.',
      },
      {
        time: 656,
        text: 'Scuttle, scuttle, scuttle! Like a crab walking on the sand! Keep your knees bent!',
      },
      {
        time: 663,
        text: 'Now scuttle back to the left! Quick feet, quick feet!',
      },
      {
        time: 668,
        text: "Let's try that again. Scuttle right! And stop! Scuttle left! And stop!",
      },
      {
        time: 676,
        text: 'Perfect! Those are Scuttle Steps! They help you stay balanced and get under the ball super fast!',
      },
      {
        time: 684,
        text: 'Everyone practice! Scuttle left and right for thirty seconds! GO!',
      },
      {
        time: 690,
        text: 'Keep going! Faster! Faster! Knees bent! Hands ready! Stay low!',
      },
      {
        time: 700,
        text: 'Ten more seconds! Five, four, three, two, one! FREEZE!',
      },
      {
        time: 710,
        text: 'Time to use our new Scuttle Steps to catch the ball!',
      },
      {
        time: 716,
        text: "Okay team, new challenge! Tosser, this time, I want you to make a gentle toss, but aim it one big step to the Catcher's RIGHT.",
      },
      {
        time: 725,
        text: "Catcher, your job is to see the ball, scuttle to the side, get underneath it, yell 'I GOT IT!', and make the catch!",
      },
      {
        time: 734,
        text: "This is tricky, so don't worry if you miss! The goal is to move your feet!",
      },
      {
        time: 741,
        text: "Let's try five catches to the RIGHT. Ready Catcher? Keep bouncing!",
      },
      {
        time: 748,
        text: 'TOSS ONE to the right!',
      },
      {
        time: 753,
        text: 'Great try! Get that ball and get ready again! Quick feet!',
      },
      {
        time: 759,
        text: 'TOSS TWO to the right!',
      },
      {
        time: 764,
        text: 'Way to move your feet! Keep it up! Reset quickly!',
      },
      {
        time: 770,
        text: 'TOSS THREE to the right!',
      },
      {
        time: 775,
        text: 'YES! You got it! See how the scuttle steps work? That was awesome!',
      },
      {
        time: 782,
        text: 'TOSS FOUR to the right!',
      },
      {
        time: 787,
        text: 'Almost! Super fast feet that time! One more try!',
      },
      {
        time: 793,
        text: 'TOSS FIVE to the right!',
      },
      {
        time: 798,
        text: 'Incredible catch! High five! You are a master of the scuttle!',
      },
      {
        time: 805,
        text: "Now, can you guess what's next? We are going to the LEFT!",
      },
      {
        time: 811,
        text: "Tosser, aim one big step to the Catcher's left. Catcher, get ready to scuttle! Five tosses!",
      },
      {
        time: 819,
        text: 'TOSS ONE to the left!',
      },
      {
        time: 824,
        text: 'Good hustle! Get ready for the next one!',
      },
      {
        time: 829,
        text: 'TOSS TWO to the left!',
      },
      {
        time: 834,
        text: 'So close! Keep your eye on it all the way!',
      },
      {
        time: 839,
        text: 'TOSS THREE to the left!',
      },
      {
        time: 844,
        text: 'Way to move! That was a great catch!',
      },
      {
        time: 849,
        text: 'TOSS FOUR to the left!',
      },
      {
        time: 854,
        text: 'You are getting faster! Great work! One more!',
      },
      {
        time: 860,
        text: 'TOSS FIVE to the left!',
      },
      {
        time: 865,
        text: "Amazing! You are on fire! Now, it's time to SWITCH!",
      },
      {
        time: 872,
        text: "New Catcher, new Tosser! Let's see you use your Scuttle Steps! Get ready!",
      },
      {
        time: 880,
        text: "We're starting with five catches to the RIGHT. Ready, set, go!",
      },
      {
        time: 887,
        text: 'TOSS ONE to the right!',
      },
      {
        time: 892,
        text: 'Great hustle! Quick feet, quick feet!',
      },
      {
        time: 898,
        text: 'TOSS TWO to the right!',
      },
      {
        time: 903,
        text: 'Nice try! Keep those hands ready!',
      },
      {
        time: 909,
        text: 'TOSS THREE to the right!',
      },
      {
        time: 914,
        text: 'You got it! Way to move and catch!',
      },
      {
        time: 920,
        text: 'TOSS FOUR to the right!',
      },
      {
        time: 925,
        text: 'Excellent work! One more to the right!',
      },
      {
        time: 931,
        text: 'TOSS FIVE to the right!',
      },
      {
        time: 936,
        text: "Fantastic! Now let's get ready to move to the LEFT! Five more tosses!",
      },
      {
        time: 945,
        text: 'TOSS ONE to the left!',
      },
      {
        time: 950,
        text: 'Good scuttle! Get set for the next one!',
      },
      {
        time: 956,
        text: 'TOSS TWO to the left!',
      },
      {
        time: 1001,
        text: 'Way to move! Keep your eye on the ball!',
      },
      {
        time: 1007,
        text: 'TOSS THREE to the left!',
      },
      {
        time: 1012,
        text: 'Yes! You caught it! Great job!',
      },
      {
        time: 1018,
        text: 'TOSS FOUR to the left!',
      },
      {
        time: 1023,
        text: "Almost! You're so fast! One more!",
      },
      {
        time: 1029,
        text: 'TOSS FIVE to the left!',
      },
      {
        time: 1034,
        text: 'You did it! Amazing hustle! You are both true athletes!',
      },
      {
        time: 1042,
        text: 'Okay, team! For our final challenge, we have the SUPER SPEED DRILL!',
      },
      {
        time: 1050,
        text: "Here's how it works. You have one minute on the clock!",
      },
      {
        time: 1056,
        text: 'The Tosser is going to make quick, gentle tosses. They can toss it straight, to the left, or to the right! Anywhere close!',
      },
      {
        time: 1065,
        text: "The Catcher has to catch as many as they can in one minute! You still have to yell 'I GOT IT!' for every single one!",
      },
      {
        time: 1074,
        text: "If you drop it, no big deal! Just get the ball and go again! Let's see how many your team can catch!",
      },
      {
        time: 1082,
        text: 'First Catcher, are you ready? Ready Stance! Bouncing feet!',
      },
      {
        time: 1088,
        text: 'Tosser, are you ready? The one-minute timer starts... NOW!',
      },
      {
        time: 1095,
        text: 'Go, go, go! Quick tosses! Quick calls! Move those feet, Catcher!',
      },
      {
        time: 1102,
        text: "Scuttle, scuttle! 'I GOT IT!' Yell it loud! Keep your eye on the ball!",
      },
      {
        time: 1110,
        text: "Two hands! You're doing great! Keep the energy up!",
      },
      {
        time: 1118,
        text: "Halfway there! Thirty seconds to go! Don't slow down! Faster, faster!",
      },
      {
        time: 1128,
        text: 'Fifteen seconds left! How many can you get? Go as fast as you can!',
      },
      {
        time: 1138,
        text: "Ten, nine, eight, seven, six, five, four, three, two, one! TIME'S UP!",
      },
      {
        time: 1149,
        text: 'Whoa! Awesome job! How many did you get? Amazing! Give your partner a high five!',
      },
      {
        time: 1157,
        text: 'Okay, switch places! FAST! New Catcher, get ready! Your one minute is on the clock!',
      },
      {
        time: 1165,
        text: "Let's see if you can beat your partner's score! Ready... SET... GO!",
      },
      {
        time: 1172,
        text: 'Hustle, hustle! Quick tosses, quick catches! Keep moving!',
      },
      {
        time: 1179,
        text: "Yell 'I GOT IT!' every time! Stay low! Watch the ball!",
      },
      {
        time: 1186,
        text: "You are doing amazing! Don't stop! Keep going!",
      },
      {
        time: 1194,
        text: 'Thirty seconds left! Halfway there! Speed it up!',
      },
      {
        time: 1202,
        text: "Can you get three more? Five more? Let's see it!",
      },
      {
        time: 1210,
        text: 'Final ten seconds! Ten, nine, eight, seven, six, five, four, three, two, one!',
      },
      {
        time: 1222,
        text: "TIME'S UP! Fantastic work! Count up your catches! You are both champions!",
      },
      {
        time: 1230,
        text: 'You have completed the Partner Pop Fly Challenge! You were incredible!',
      },
      {
        time: 1237,
        text: 'You learned the Ready Stance, how to make a Superstar Call, and how to use your Scuttle Steps to make amazing catches!',
      },
      {
        time: 1245,
        text: 'Give your partner a super loud high five! Now give them a double high five!',
      },
      {
        time: 1252,
        text: 'You guys are official Pop Fly Masters! Great job today!',
      },
      {
        time: 1258,
        text: 'See you next time for another challenge!',
      },
    ],
    timeTotal: 1260,
    equipment: 'Soft ball or rolled socks, two gloves optional',
  },
  //done 1
  {
    id: 2165,
    name: 'Partner Relay Feet and Aim',
    categories: ['Partner', 'advanced'],
    sports: ['baseball'],
    difficulty: 'advanced',
    skill: 'Partner',
    points: 45,
    instructions:
      "Get ready for an awesome baseball mission with your partner! We're going to become super-fast relay racers! You'll learn how to catch, turn, and throw like a pro, all while playing a super fun game. Grab a soft ball or even a pair of rolled-up socks, and let's get moving! No boring stuff, just non-stop action!",
    timedInstructions: [
      {
        time: 0,
        text: "Hey team! Let's get started! Stand about 10 big steps away from your partner. Get your glove on if you have one. Start bouncing on your toes like a boxer! Light feet, quick feet!",
      },
      {
        time: 30,
        text: "Okay, let's get into our SUPERHERO stance! Knees bent, feet a little wider than your shoulders, and hands up like you're ready to catch anything! Let's call this the 'Ready Rocket' position. Hold it! Now bounce, bounce, bounce in your spot! Don't let your heels touch the ground!",
      },
      {
        time: 90,
        text: "Still in your Ready Rocket stance, let's shuffle side to side! Shuffle left! Shuffle right! Keep those hands up! Imagine a laser is trying to get you if you stand still! Go, go, go!",
      },
      {
        time: 150,
        text: "Awesome! Now, let's do some quick, easy tosses with your partner. Just focus on catching it and staying in your Ready Rocket stance. Bouncing on your feet the whole time! Let's do ten catches each!",
      },
      {
        time: 180,
        text: "Great job! Now for the secret move! We're going to catch the ball and turn our bodies, all in one super-fast motion! When you catch the ball, bring it right to the middle of your chest, and turn your whole body to the side, away from your partner. Your feet, your tummy, everything points to the side! Let's try it without the ball first. Ready... CATCH and TURN! Again, CATCH and TURN! Make it snappy!",
      },
      {
        time: 240,
        text: "Okay, let's do it with the ball! Your partner will toss it to you. You're going to CATCH and TURN! Then, turn back and toss it to your partner so they can try. Keep your feet moving! Let's see who has the fastest turn! We're doing this for two whole minutes! Go, go, go! Stay bouncy!",
      },
      {
        time: 360,
        text: "Amazing! Now let's add the next piece! After you CATCH and TURN, you're going to take a little step with your back foot. It's a tiny hop backwards. So it's CATCH, TURN, and STEP BACK! Practice that motion. Catch, turn, step back! Feels like a little dance move, right? Now try it with your partner! They toss, you catch, turn, step back! Then toss it back. Keep the energy up!",
      },
      {
        time: 480,
        text: "You guys are crushing it! Now for the superpower... AIMING! After you CATCH, TURN, and STEP BACK, you're going to point your glove hand right at your target. Your target is your partner's chest! So the move is: CATCH, TURN, STEP BACK, and POINT! Let's practice it together without the ball. Point that glove like you're aiming a laser beam!",
      },
      {
        time: 540,
        text: "Okay, time to try it for real! Partner tosses, you do the whole thing: CATCH, TURN, STEP BACK, and POINT! Hold that point for a second to lock on your target! Then just gently toss it back. We are just practicing the aim right now, not a big throw. Let's go for two minutes! Bounce on your feet while you wait for the toss!",
      },
      {
        time: 660,
        text: "Alright, it's time to put it all together and make a real throw! We're going to do everything, but this time, after you point, you'll step forward with your other foot and THROW! So it's: CATCH, TURN, STEP BACK, POINT, STEP FORWARD, and THROW! Let's break it down. First, the feet. Your back foot steps back, then your front foot steps forward towards your partner. Practice just the feet. Back foot, front foot. Back, front. Now add the throw!",
      },
      {
        time: 720,
        text: "Let's go! Four minutes of perfect relay throws! Keep shuffling your feet while you wait! Bounce, bounce, bounce! Remember all the steps! CATCH, TURN, STEP BACK, POINT, STEP, THROW!",
      },
      {
        time: 900,
        text: "Time for a challenge! This is the 'Quick Turn Relay Race'! You and your partner are a team. The goal is to see how many perfect relay throws you can make in three minutes. A perfect throw means you do all the steps: CATCH, TURN, STEP BACK, POINT, STEP, and THROW!",
      },
      {
        time: 930,
        text: "Ready? The timer starts in 3... 2... 1... GO! Count your catches out loud! One! Two! Three! Keep those feet moving! Don't stand still! Shuffle, shuffle, shuffle! Faster! Quicker turns! Point that glove!",
      },
      {
        time: 1020,
        text: "Great job, keep it up! Halfway there! Don't get sloppy! Every step counts! Come on team, let's get a new high score! Keep bouncing while you wait for the throw! Quick feet!",
      },
      {
        time: 1110,
        text: "TIME'S UP! Pencils down! Awesome work! How many did you get? High five your partner! Grab a super quick drink of water if you need it. You have 30 seconds!",
      },
      {
        time: 1170,
        text: 'And... back to your spots! Start bouncing! Get ready for the next challenge!',
      },
      {
        time: 1200,
        text: "Okay, next challenge! This is called 'Hot Potato'! The goal is to get the ball out of your glove as fast as possible. No big throws! Just CATCH and quick TOSS back. We are focusing on fast hands and fast feet!",
      },
      {
        time: 1230,
        text: "You need to stay in your Ready Rocket stance the whole time! Knees bent, feet bouncing! Let's see how many super-fast catches you can get in two minutes! Ready, set, GO! Hot potato, hot potato! Quick hands! Don't let the ball stick in your glove!",
      },
      {
        time: 1320,
        text: 'Bounce, bounce, bounce! Faster! Imagine the floor is lava! Keep moving! One more minute! Push it! Go, go, go!',
      },
      {
        time: 1380,
        text: 'And STOP! Fantastic speed! You guys are on fire! Shake out your hands, shake out your feet! Great job! Now, get ready for our final big race!',
      },
      {
        time: 1440,
        text: "Okay team, this is the final mission! The 'Accuracy Challenge'! This time, it's not just about speed, it's about hitting the target! Your partner will make a target with their hands. The goal is to hit their hands with the ball. You still have to do all the relay steps!",
      },
      {
        time: 1500,
        text: "You have four minutes to get as many target HITS as you can! Every hit is one point! Let's go! Ready... Set... GO! CATCH, TURN, STEP BACK, POINT, STEP, THROW! Aim for the target!",
      },
      {
        time: 1620,
        text: "If you miss, that's okay, just get the next one! Keep shuffling your feet! Talk to your partner! 'Target up!' Good throw! Let's go! Two more minutes! Stay focused! Eyes on the prize! Point that glove right at the target! You got this!",
      },
      {
        time: 1740,
        text: "Thirty seconds left! Let's get three more perfect throws! Go, go, go! Don't stop moving!",
      },
      {
        time: 1770,
        text: "Ten, nine, eight, seven, six, five, four, three, two, one... TIME! That's it! You did it! Count up your points! Awesome job today, relay racers! You guys are pros! High five your partner! Mission complete!",
      },
    ],
    timeTotal: 1800,
    equipment: 'Soft ball or rolled socks, two gloves optional',
  },
  // Room to add 6507–6510 later as needed
];

export default baseballPartnerDrills;
